import { BooleanCompare } from "@redotech/redo-model/segments/segment-where-condition";
import { memo } from "react";
import { RedoListItem } from "../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { SegmentBuilderText } from "../segment-builder-text";

const booleanOptions: RedoListItem<boolean>[] = [
  { id: "true", text: "true", type: "text", value: true },
  { id: "false", text: "false", type: "text", value: false },
];

export const BooleanFilter = memo(function BooleanFilter({
  comparison,
  setComparison,
}: {
  comparison: BooleanCompare;
  setComparison: (condition: BooleanCompare) => void;
}) {
  return (
    <>
      <SegmentBuilderText>is</SegmentBuilderText>
      <RedoSingleSelectDropdownInput<boolean>
        fitToAnchor={false}
        flexGrow={false}
        options={booleanOptions}
        optionSelected={({ item }) => {
          setComparison({ ...comparison, value: item.value });
        }}
        selectedItem={booleanOptions.find((o) => o.value === comparison.value)}
        size="xs"
      />
    </>
  );
});
